module.exports = __webpack_public_path__ + "static/media/carousel_quienes_somos_5.6c649eee.jpg";